export default __webpack_public_path__ + "static/media/ra.454ee720.jpg";